import { useMemo } from 'react';

import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const FoodicsShippingTransactionReport = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.string,
				showOnMobile: true,
				show: false
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.number,
				showCopyButton: true
			},
			{ Header: 'companyName', accessor: 'companyName', filterType: FilterType.string },
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,

				showOnMobile: true
			},
			{
				Header: 'orderStatus',
				accessor: 'orderStatus',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				width: 90
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.string
			},
			{
				Header: 'transactionStatus',
				accessor: 'transactionStatus',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS,
				width: 90
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompany',
				filterType: FilterType.string
			},

			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.string
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string
			},
			{
				Header: 'createdAt',
				accessor: 'createdAt',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				width: 150,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'createdAt',
				accessor: 'createdAt',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				show: false
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="foodicsShippingTransactionReportTitle"
				lordIcon={
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz'
				}
			/>
			<DynamicList
				id={DYNAMICLISTS.FOODICS_SHIPPING_TRANSACTION_REPORT}
				columns={columns}
				fetchUrl={REPORT.FOODICS.GET_FOODICS_TRANSACTIONS}
				exportName="createShipmentErrorMapping"
			/>
		</div>
	);
};

export default FoodicsShippingTransactionReport;
